export class MeasureInfoModel {
    public id: number;
    public customText: string;
    public tipCod: string;
    public tipDex: string;
    public cndCod: string;
    public cndDex: string;
    public mcoCod: string;
    public mcoDex: string;
    public altCod: string;
    public altDex: string;
    public cirCod: string;
    public cirDex: string;

    constructor(value: JSON) {
        this.tipCod = value["tipCod"];
        this.tipDex = value["tipDex"];
        this.cndCod = value["cndCod"];
        this.cndDex = value["cndDex"];
        this.mcoCod = value["mcoCod"];
        this.mcoDex = value["mcoDex"];
        this.altCod = value["altCod"];
        this.altDex = value["altDex"];
        this.cirCod = value["cirCod"];
        this.cirDex = value["cirDex"];
    }
}